import React from 'react'
import ReactDOM from 'react-dom'
import './styles/styles.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store/store'
import { Provider } from 'react-redux'
import { exchangeHandoff } from './utils/getAuthToken'
import { startKeepAlive } from './utils/keepAlive'

// Swap the one-time sign-in code in the address for the token first (getAuthToken.js), then start.
exchangeHandoff().finally(() => {
    startKeepAlive()
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <App />
            </Provider>
        </React.StrictMode>,
        document.getElementById('root')
    )
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
